/** Kept in sync with src/stages.js on the server. */

export const STAGE_LABELS = {
  new_lead: 'New Lead', visit_scheduled: 'Visit Scheduled', visited: 'Visited',
  quote_sent: 'Quote Sent', quote_accepted: 'Quote Accepted', quote_rejected: 'Quote Rejected',
  signed: 'Signed',
  job_in_progress: 'In Progress', job_completed: 'Completed',
  invoice_sent: 'Invoice Sent', paid: 'Paid · Closed',
};

export const STAGE_COLOR = {
  new_lead: 'bg-purple', visit_scheduled: 'bg-amber', visited: 'bg-amber',
  quote_sent: 'bg-blue', quote_accepted: 'bg-green', quote_rejected: 'bg-red',
  signed: 'bg-green',
  job_in_progress: 'bg-blue', job_completed: 'bg-green',
  invoice_sent: 'bg-amber', paid: 'bg-green',
};

export const PIPELINE_ORDER = [
  'new_lead', 'visit_scheduled', 'visited', 'quote_sent', 'quote_accepted',
  'signed', 'job_in_progress', 'job_completed', 'invoice_sent', 'paid',
];

export const stageLabel = (s) => STAGE_LABELS[s] || s || '—';
export const stageColor = (s) => STAGE_COLOR[s] || 'bg-grey';
